// extracted by mini-css-extract-plugin
module.exports = {"boxWrapper":"Terms_boxWrapper__2LmaC"};